import Env from '../base/env'
import Channels from '../base/channels'
import Draggable from 'gsap/Draggable'
import ThrowPropsPlugin from '../vendor/gsap-bonus/ThrowPropsPlugin';
import Waypoint from '../vendor/waypoints';
import WheelIndicator from 'wheel-indicator'
import ScrollTo from 'gsap/ScrollToPlugin.js'
import raf from 'raf'
import Hammer from 'hammerjs'

export default class Slideline
{
    constructor(view)
    {
        this.view = view
        this.$collection = this.view.querySelector('.jsCollection')
        this.$moveable = this.view.querySelector('.jsMoveable')
        this.$btnNext = this.view.querySelector('.jsNext')
        this.$btnPrev = this.view.querySelector('.jsPrevious')
        this.$filler = this.view.querySelector('.jsFiller')
        this.$items = []
        this.$waypoints = []
        this.$listener = this.view.querySelector('.jsJourney--listener')
        this.$html = Env.$html
        this.funcResize = this.reset.bind(this)
        this.snapPoints = []
        this.waypointsInstances =   []
        this.draggable = undefined;
        this.indicator = false;
        this.hammerView = new Hammer(this.$collection)
        this.hammerView.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
        this.bounds = { minX : 0 , maxX : 0 , minY : 0 , maxY : 0 }
        this.wheelAssets =  { durationEase : 1.6 , typeEase : Power4.easeOut }
        this.direction = { x : 0 , y : 0 }
        this.scrollListenerBoundY = 0
        this.raf = undefined;
        this.draggable = undefined
        this.getPosX = 0
        this.percentage = 0
        this.acceleration = 1.8
        this.CURRENT_INDEX = 0
        this.TOTAL = false
        this.LOCKED = false
        this.FREE_SCROLL = true
        this.IS_TOUCH = 'ontouchstart' in window
    }

    destroyWaypoint()
    {
        for(let i = 0; i<this.waypointsInstances.length; i++) {
            const instance = this.waypointsInstances[i]
            instance.destroy()
        }
        this.waypointsInstances = []
    }

    destroy()
    {
        raf.cancel(this.raf)
        this.destroyWaypoint();
        Channels.removeListener('window::smartresize', this.funcResize);
    }

    drag()
    {
        this.draggable = Draggable.create(
            this.$moveable,
            {
                cursor: 'default',
                type:"x",
                edgeResistance:.9,
                dragResistance : .2,
                force3D : true,
                lockAxis : true,
                throwProps:true,
                maxDuration:1.5,
                throwResistance: 5000,
                dragClickables : true,
                snap: { x: this.snapPoints },
                bounds : {minX : 0 , maxX : this.snapPoints[this.TOTAL - 1] },
                onThrowComplete : ()=>
                {
                    this.LOCKED = false
                }
            }
        );
        this.setWaypoint()
    }

    events()
    {
        if(this.FREE_SCROLL && !this.IS_TOUCH) {
            this.wheelOn();
        } else {
            this.indicator = new WheelIndicator({
                elem: this.view,
                callback: (e)=>{
                    if(e.direction == 'down')
                    {
                        this.goToNext()
                    }
                    else
                    {
                        this.goToPrevious()
                    }
                }
            });
            this.indicator.getOption('preventMouse');
        }

        if(this.$btnPrev != null) {
            this.$btnPrev.addEventListener('mouseenter',()=>{
                const $itemPrev = this.$items[this.CURRENT_INDEX - 1]
                if($itemPrev != null) $itemPrev.classList.add('hovered--previous')
            })
            this.$btnPrev.addEventListener('mouseleave',()=>{
                const $itemPrev = this.$items[this.CURRENT_INDEX - 1]
                if($itemPrev != null) $itemPrev.classList.remove('hovered--previous')
            })
            this.$btnPrev.addEventListener('click',()=>{
                this.goToPrevious()
            })
        }
        if(this.$btnNext != null) {
            this.$btnNext.addEventListener('mouseenter',()=>{
                const $itemNext = this.$items[this.CURRENT_INDEX + 1]
                if($itemNext != null) $itemNext.classList.add('hovered--next')
            })
            this.$btnNext.addEventListener('mouseleave',()=>{
                const $itemNext = this.$items[this.CURRENT_INDEX + 1]
                if($itemNext != null) $itemNext.classList.remove('hovered--next')
            })
            this.$btnNext.addEventListener('click',()=>{
                this.goToNext()
            })
        }


        // SWIPE
        this.hammerView.on('swipeup' , (ev)=>
        {
            this.goToNext()
        })

        this.hammerView.on('swipedown' , (ev)=>
        {
            this.goToPrevious()
        })

        Channels.on('window::smartresize',this.funcResize)
    }

    goToPrevious()
    {
        if(this.LOCKED == false)
        {
            let currentIndex = this.CURRENT_INDEX
            currentIndex--
            if(currentIndex < 0) {
                currentIndex = 0
            }
            this.moveToSnap(currentIndex)
        }

    }

    goToNext()
    {
        if(this.LOCKED == false)
        {
            let currentIndex = this.CURRENT_INDEX
            currentIndex++
            if(currentIndex >= this.TOTAL) {
                currentIndex = this.TOTAL - 1
            }
            this.moveToSnap(currentIndex)
        }
    }


    moveToSnap(index)
    {
        let timeline = new TimelineLite()
        const newPostX = this.snapPoints[index]

        // Bg Color
        this.updateBgColor(index)

        timeline.kill()
        timeline.add([
            TweenLite.to(
                this.$moveable,
                .7,
                {
                    x: newPostX,
                    ease : Cubic.easeInOut,
                    onStart : ()=> {
                        this.LOCKED = true;
                    },
                    onComplete : ()=> {

                    }
            }),
        ])
        timeline.add(()=>{
            this.LOCKED = false;
        })
    }

    moveTo(_value)
    {
        const newPostX = _value * this.acceleration
        const distanceToDo = newPostX + this.$moveable._gsTransform.x

        TweenLite.killTweensOf(this.$moveable);
        // Startpoint
        if(distanceToDo > 0)
        {
            TweenLite.to( this.$moveable , this.wheelAssets.durationEase , { x : 0 , ease : this.wheelAssets.typeEase , onComplete : ()=> {
                    this.LOCKED = false;
                }
            });
        }
        // Endpoint
        else if(distanceToDo < this.bounds.maxX)
        {
            TweenLite.to( this.$moveable , this.wheelAssets.durationEase , { x : this.bounds.maxX , ease : this.wheelAssets.typeEase , onComplete : ()=> {
                this.LOCKED = false;
                }
            });
        }
        else
        {
            TweenLite.to( this.$moveable , this.wheelAssets.durationEase , { x:'+='+ (newPostX) , ease : this.wheelAssets.typeEase , onComplete : ()=> {
                this.LOCKED = false;
                }
            });
        }
    };


    resize()
    {
        const viewport = Env.framework.toolbox.getViewport()
        const dimensions = this.$items[0].getBoundingClientRect()
        const centerX = viewport.width - dimensions.width
        const xPos = centerX / 2
        const itemWidth = dimensions.width
        let setMarginRight = 0
        this.$collection.style.left = `${xPos}px`
        for(let i = 0; i < this.$items.length; i++) {
            // Item
            const $item = this.$items[i]
            $item.style.marginRight = `${setMarginRight}px`
            // Snapper
            const snap = (itemWidth + setMarginRight) * i * -1
            this.snapPoints.push(snap)
            // Waypoint
            const $waypoint = this.$waypoints[i]
            $waypoint.style.height = `${viewport.height}px`
        }
        this.$btnNext.style.width = `${xPos - setMarginRight}px`
        this.$btnPrev.style.width = `${xPos - setMarginRight}px`
        // Bounds
        this.bounds.maxX = this.snapPoints[this.TOTAL - 1]
        this.bounds.maxY = 0
        // Listener
        const listenerScrollHeight = viewport.height * this.TOTAL
        this.$listener.querySelector('.receptor').style.height = `${listenerScrollHeight}px`
        this.scrollListenerBoundY = listenerScrollHeight - viewport.height
        // Fn
        this.drag()
    }

    reset()
    {
        this.draggable[0].kill()
        this.snapPoints = []
        TweenLite.set(this.$moveable , { x : 0 })
        this.destroyWaypoint();
        this.resize();
    }

    returnColor(index)
    {
        const $itemActive = this.$items[index]
        const getColor = $itemActive.getAttribute('data-color')
        return getColor
    }


    setup()
    {
        this.events()
        this.setVars()
        this.resize()
        this.watcher()
    }

    setVars()
    {
        this.$items = this.view.querySelectorAll('.jsItem')
        this.TOTAL = this.$items.length
        for(let i = 0; i < this.$items.length; i++) {
            const waypoint = document.createElement('div')
            waypoint.classList.add('waypoint')
            waypoint.classList.add('jsWaypoint')
            waypoint.setAttribute('data-index',i)
            waypoint.setAttribute('data-offset','0%')
            this.$waypoints.push(waypoint)
            this.$listener.querySelector('.receptor').appendChild(waypoint)
        }
    }

    setWaypoint()
    {
        const SELF = this
        for(let i = 0; i < this.TOTAL; i++) {
            const $waypoint = this.$waypoints[i]
            const instance = new Waypoint({
                element: $waypoint,
                handler: function(direction) {
                    let getIndex = this.element.getAttribute('data-index') * 1
                    if(direction == "up")
                    {
                        getIndex--
                    }
                    SELF.CURRENT_INDEX = getIndex
                    SELF.updateStatus()
                },
                context: this.$listener,
                offset: '50%'
            })
            this.waypointsInstances.push(instance)
        }
    }

    updateBgColor(index)
    {
        const getColor = this.returnColor(index)
        this.$filler.style.backgroundColor = getColor


    }

    updateStatus()
    {
        this.$btnPrev.classList.remove('is--disabled')
        this.$btnNext.classList.remove('is--disabled')
        for(let $item of this.$items) {
            $item.classList.remove('is--active')
        }
        const $itemActive = this.$items[this.CURRENT_INDEX]
        $itemActive.classList.add('is--active')
        const getLink = $itemActive.getAttribute('href')
        if(this.CURRENT_INDEX == 0) {
            this.$btnPrev.classList.add('is--disabled')
        }
        if(this.CURRENT_INDEX == this.TOTAL - 1) {
            this.$btnNext.classList.add('is--disabled')
        }
        if(this.LOCKED == false)
        {
            this.updateBgColor(this.CURRENT_INDEX)
        }
    }


    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })

        this.getPosX = this.$moveable._gsTransform.x
        this.percentage = this.getPosX / this.bounds.maxX
        TweenLite.set(this.$listener , { scrollTo : { y : this.percentage * this.scrollListenerBoundY }})
    }

    wheelOn()
    {
        const wheel = (e)=>{
            let delta
            if(typeof e.wheelDelta != "undefined") {
                delta = e.wheelDelta
            } else {
                delta = e.deltaY
            }
            this.wheelTask(e);
            e.preventDefault()
            e.stopPropagation()
        }
        this.view.addEventListener('wheel', wheel,true); // for Firefox
        this.view.addEventListener('mousewheel', wheel,true); // for everyone else
    }

    wheelTask(_e)
    {
        const directionX = (typeof _e.wheelDeltaX != "undefined")?_e.wheelDeltaX:_e.deltaX * -100
        const directionY = (typeof _e.wheelDeltaY != "undefined")?_e.wheelDeltaY:_e.deltaY * -100
        const checkY = Math.abs(directionY)
        const checkX = Math.abs(directionX)

        if(!this.LOCKED) {
            this.LOCKED = false;
            if(checkX >= checkY) {
                this.moveTo(directionX);
            } else {
                this.moveTo(directionY);
            }
        }
    };

}


// WEBPACK FOOTER //
// ./resources/js/components/Slideline.js